import { datadogRum } from '@datadog/browser-rum';

let isInitialized = false;

type Practitioner = {
  id: string;
  name: string;
  email: string;
};

type AnonymousUser = {
  name: string;
  practitioner_name: string;
  appointment_id: string | number;
};

export const RUM = {
  init: () => {
    if (isInitialized) return;
    if (import.meta.env.VITE_DD_ENABLE == 'true') {
      isInitialized = true;
      datadogRum.init({
        applicationId: import.meta.env.VITE_DD_APPLICATION_ID,
        clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
        site: import.meta.env.VITE_DD_SITE,
        service: import.meta.env.VITE_DD_SERVICE,
        env: import.meta.env.VITE_DD_ENVIRONMENT,
        sessionSampleRate: parseInt(import.meta.env.VITE_DD_SAMPLE_RATE),
        sessionReplaySampleRate: parseInt(
          import.meta.env.VITE_DD_SESSION_SAMPLE_RATE
        ),
        version: import.meta.env.VITE_COMMIT_HASH,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'allow',
      });
    }
  },
  setUser: (user: Practitioner | AnonymousUser) => {
    if (import.meta.env.VITE_DD_ENABLE == 'true') {
      datadogRum.setUser(user);
    }
  },
  getInstance: () => {
    if (isInitialized) {
      return datadogRum;
    }
    return null;
  },
};
